import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG } from '@application/config';
import { IStandardMessage, TAccessGroup, IMessageSettings, IAccessSettings, IAdvertisementSettings } from '../entities/access-settings.interface';
import { TSubscriptionSettings } from '@financial/data-access';

@Injectable({ providedIn: 'root' })
export class AccessSettingsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl;

  public getControlAccess(): Observable<IAccessSettings> {
    return this.http.get<IAccessSettings>(
      this.apiUrl.access_service + `/AccessSettings`,
      { withCredentials: true }
    );
  }

  public getAllAccessMessages(): Observable<IMessageSettings> {
    return this.http.get<IMessageSettings>(
      this.apiUrl.access_service + `/MessageSettings`,
      { withCredentials: true }
    );
  }

  public getStandardMessages(): Observable<IStandardMessage> {
    return this.http.get<IStandardMessage>(
      this.apiUrl.access_service + `/MessageSettings`,
      { withCredentials: true }
    );
  }

  public updateMessageSettings(body: Partial<IMessageSettings>): Observable<IMessageSettings> {
    return this.http.patch<IMessageSettings>(
      this.apiUrl.access_service + `/MessageSettings`,
      body,
      { withCredentials: true }
    );
  }

  public updateAccessControl(body: Partial<IAccessSettings>): Observable<IAccessSettings> {
    return this.http.post<IAccessSettings>(
      this.apiUrl.access_service + `/AccessSettings`,
      body,
      { withCredentials: true }
    );
  }

  public getAccessGroup(id: string): Observable<TAccessGroup> {
    return this.http.get<TAccessGroup>(`${this.apiUrl.acesso}/GrupoDeAcesso/ObterPorId?id=${id}`, {
      withCredentials: true
    });
  }

  public updateAccessGroup(accessGroup: TAccessGroup): Observable<TAccessGroup> {
    return this.http.post<TAccessGroup>(`${this.apiUrl.acesso}/GrupoDeAcesso/Atualizar`, accessGroup, {
      withCredentials: true
    });
  }

  public createAccessGroup(accessGroup: TAccessGroup): Observable<TAccessGroup> {
    return this.http.post<TAccessGroup>(`${this.apiUrl.acesso}/GrupoDeAcesso/Adicionar`, accessGroup, {
      withCredentials: true
    });
  }

  public deleteAccessGroup(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl.acesso}/GrupoDeAcesso/Excluir?id=${id}`, {
      withCredentials: true
    });
  }

  public getAdvertisementSettings(): Observable<IAdvertisementSettings> {
    return this.http.get<IAdvertisementSettings>(
      this.apiUrl.access_directory_service + `/AdvertisementSettings`,
      { withCredentials: true }
    );
  }

  public updateAdvertisementSettings(body: Partial<IAdvertisementSettings>): Observable<IAdvertisementSettings> {
    return this.http.patch<IAdvertisementSettings>(
      this.apiUrl.access_directory_service + `/AdvertisementSettings`,
      body,
      { withCredentials: true }
    );
  }

  public getSubscriptionSettings(): Observable<TSubscriptionSettings> {
    return this.http.get<TSubscriptionSettings>(
      `${this.apiUrl.subscription_service}/SubscriptionSettings/GetAsync`,
      { withCredentials: true }
    );
  }

  public updateSubscriptionSettings(body: Partial<TSubscriptionSettings>): Observable<TSubscriptionSettings> {
    return this.http.patch<TSubscriptionSettings>(
      `${this.apiUrl.subscription_service}/SubscriptionSettings`,
      body,
      { withCredentials: true }
    );
  }
}
